import React, { Component } from "react";
import mixpanel from "mixpanel-browser";
import { strings, gTagEvent, showErrorNotification } from "../../../helpers";
import VerificationView from "./VerificationView";
import { verifyUser, resendVerificationCode } from "../../../services";
import ReactPixel from "react-facebook-pixel";
import {
  redirectToPatientSite,
  redirectToLoggedInSite
} from "../Signin/ClinicLoginActions";
class VerifyClinicContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      verificationCode: "",
      error: false,
      errorMsg: "",
      phoneNumber: "",
      countryCode: "91",
      showSendSuccessMsg: false,
      resendServerError: false,
      verifyServerError: false,
      showTimer: true,
      timerCount: 60,
      emailId: null,
      mixpanelFromParam: "",
      isProcessing: false
    };
  }

  componentDidMount() {
    this.onTimer();
    this.setState({
      phoneNumber: this.props.phoneNumber,
      countryCode: this.props.countryCode,
      emailId: this.props.userEmail,
      mixpanelFromParam: this.props.eventType,
    });
    // log mixpanel event
    mixpanel.track("OTP Screen Viewed");
  }

  /**
   * @function handleChange
   * @param e
   * @return nothing
   * @desc This method handles input changes in verification code screen
   */
  handleChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value.replace(/\s/g, ""),
      error: false,
      errorMsg: "",
      verifyServerError: false,
      resendServerError: false
    });
  };

  /**
   * @function handleOTPChange
   * @param "otp"
   * @desc This method handles input changes in verification code input
   */
  handleOTPChange = otp => {
    this.setState({
      verificationCode: otp,
      error: false,
      errorMsg: "",
      verifyServerError: false,
      resendServerError: false
    });
  };

  /**
   * @function onTimer
   * @desc This method shows the timer for 60 seconds, after verification screen is shown to the user
   */
  onTimer = () => {
    const timer = setInterval(() => {
      let count = this.state.timerCount;
      count -= 1;
      if (count < 0) {
        this.setState({
          showTimer: false,
          timerCount: 60
        });
        clearInterval(timer);
      } else {
        this.setState({
          timerCount: count
        });
      }
    }, 1000);
  };

  /**
   * @function setStateForInvalidData
   * @param errorText
   * @return nothing
   * @desc This method sets error messages state, to be shown to the user in case of any error
   */
  setStateForInvalidData = errorText => {
    this.setState({
      error: true,
      errorMsg: errorText,
      showSendSuccessMsg: false,
      verifyServerError: false,
      resendServerError: false
    });
  };

  /**
   * @function verifyUserAction
   * @param phoneNumber
   * @param countryCode
   * @param verificationCode
   * @desc This method calls verifyuser service to handle verification of the user post login or signup
   */
  verifyUserAction = (
    phoneNumber,
    countryCode,
    verificationCode,
    mixpanelFromParam,
    accountTypePatient
  ) => {
    this.setState({ isProcessing: true });

    verifyUser(
      phoneNumber,
      countryCode,
      verificationCode,
      mixpanelFromParam
    ).then(
      response => {
        this.setState({ isProcessing: false });
        if (response?.data?.data) {
          // if the user has signed in from mobile, then prompt user to continue rest of the app through web
          const responseObj = response.data;

          // track event only in case of production environment
          if (window.location.hostname === "auth.kulcare.com") {
            gTagEvent();
            // facebook pixel tracking
            ReactPixel.track("CompleteRegistration");
          }
          if (accountTypePatient) {
            // if user is patient, then redirect to patient site
            redirectToPatientSite(true, responseObj);
          } else {
            // if user is not patient, then redirect to logged in site
            redirectToLoggedInSite(responseObj, null, null, "signup");
          }
        } else if (response?.data?.errors) {
          // handle errors in case of server error
          this.processErrors(response.data.errors);
        }
      },
      error => {
        this.setState({ isProcessing: false });
        showErrorNotification(
          "There was some error while processing your request."
        );
      }
    );
  };

  /**
   * @function handleSubmit
   * @param e
   * @return nothing
   * @desc This method checks for valid input and
   *  submits verify code for verification
   */
  handleSubmit = e => {
    e.preventDefault();
    const {
      verificationCode,
      phoneNumber,
      countryCode,
      mixpanelFromParam
    } = this.state;
    const { accountTypePatient } = this.props;

    // when verification code is empty
    if (!verificationCode) {
      this.setStateForInvalidData(strings.empty_code_error);
      return false;
    }

    // when phone, country code and verification code is present then allow user to get verified
    if (phoneNumber && countryCode && verificationCode) {
      this.verifyUserAction(
        phoneNumber,
        countryCode,
        verificationCode,
        mixpanelFromParam,
        accountTypePatient
      );
    } else {
      // handle the case when any of the required input is missing
      this.setStateForInvalidData(strings.param_missing);
    }
  };

  /**
   * @function handleResendCode
   * @param e
   * @return nothing
   * @desc This method handles resend verification code
   */
  handleResendCode = e => {
    e.preventDefault();
    const { phoneNumber, countryCode } = this.state;
    // call to method
    this.resendCode(phoneNumber, countryCode);
  };

  /**
   * @function resendCode
   * @param "phoneNumber", "countryCode"
   * @desc This method handles resend verification code to the user, if the user somehow did not recieve any OTP
   */
  resendCode = (phoneNumber, countryCode) => {
    this.setState({ isProcessing: true, error: false });
    // call to the service that handles resending verification code
    resendVerificationCode(phoneNumber, countryCode).then(
      response => {
        this.setState({ isProcessing: false });
        if (response?.data?.success) {
          this.setState({
            showSendSuccessMsg: true,
            error: false,
            errorMsg: "",
            verifyServerError: false,
            resendServerError: false,
            showTimer: true
          });
        } else {
          this.processErrors(response.data.errors);
        }
      },
      error => {
        this.setState({ isProcessing: false });
        showErrorNotification(
          "There was some error while processing your request"
        );
      }
    );
  };

  /**
   * @function processErrors
   * @param "errorObj", "countryCode"
   * @desc This method handles processing errors returned from api, and setting the state for displaying them on the UI
   */
  processErrors = errorObj => {
    let errorMsg = "Verification code is invalid";
    switch (errorObj.source) {
      case "account":
        errorMsg = "This account already exists with us";
        break;
      case "verification_code":
        errorMsg = "Code is invalid";
        break;
      default:
        break;
    }
    this.setState({ error: true, errorMsg });
  };

  render() {
    return (
      <VerificationView
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        isProcessing={this.state.isProcessing}
        error={this.state.error}
        errorMsg={this.state.errorMsg}
        verificationCode={this.state.verificationCode}
        handleResendCode={this.handleResendCode}
        isResendCodeProcessing={this.props.isResendCodeProcessing}
        showSendSuccessMsg={this.state.showSendSuccessMsg}
        showTimer={this.state.showTimer}
        timerCount={this.state.timerCount}
        phoneNumber={this.state.phoneNumber}
        verifyServerError={this.state.verifyServerError}
        resendServerError={this.state.resendServerError}
        emailId={this.state.emailId}
        handleOTPChange={this.handleOTPChange}
        countryCode={this.state.countryCode}
      />
    );
  }
}
export default VerifyClinicContainer;
